import BaseConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { callFinder, setSelectedStage } from '../Reducers/Configurator/Actions';
import { MATERIAL } from '../Constants/Steps';

class ConfiguratorService extends BaseConfiguratorService {
  doFinderCall() {
    return Services.store.dispatch(withGlobalLoader(callFinder()));
  }
  async loadInitialConfiguration() {
    const params = {};
    const basePath = getConf('routingBasePath', '/');
    const itemRegex = new RegExp(`${basePath}(code|identifier):([^/]+)`);
    const results = itemRegex.exec(location.pathname);
    if (results) {
      params[results[1]] = results[2];
    }
    if (params.identifier || params.code) {
      await super.loadInitialConfiguration();
      params.code && Services.store.dispatch(setSelectedStage(MATERIAL));
    } else {
      return this.doFinderCall();
    }
  }
}

export default ConfiguratorService;
